<div class="">
  <mat-horizontal-stepper *ngIf="idiomas">

      <mat-step *ngFor="let idioma of idiomas; index as i;" label="{{'NOMBREIDIOMAS.'+idioma.clave|translate}}" state="idiomaIco" errorMessage="{{'CERTIFICAR.ADICIONALES.TRADUCCIONES.NOTYET' | translate}}">

        <ng-container *ngIf="cargando; else cargaCompleta">
          <div fxLayout="column" fxLayoutAlign="space-between center" class="pt-40">
            <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
            <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
          </div>
        </ng-container>

        <ng-template #cargaCompleta>
          <ng-container *ngIf="idioma.tipoIdioma==1">
          <ng-container *ngIf="!sinReactivos; else sinReactivosMsg">
            <div fxLayout="column" fxLayoutAlign="start stretch" class="mat-elevation-z4 p-20 mb-20" *ngFor="let pregunta of reactivosMostrar; let j = index;">
              <div fxLayout="row" fxLayoutAlign="start stretch">
                <h3><b>{{ (j+1) }}. {{pregunta[idioma.clave]}}</b></h3>
              </div>
              <div class="tac" fxLayout="row" fxLayoutAlign="space-around stretch">
                <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="45" *ngFor="let pespectiva of ['EMPRESA']">
                  <p>{{'FOCUS.REACTIVOS.STEPS.3.TEXTOS.'+idioma.clave+'.'+pespectiva | translate}}</p>
                  <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
                    <div class="botonReactivo" fxLayout="column" fxLayoutAlign="start center" fxFlex="16" *ngFor="let boton of botones; let k = index;">
                      <img *ngIf="guardados.caritas == 1" src="assets/images/icons/{{boton.amarilla}}" alt="">
                      <img *ngIf="guardados.caritas == 0" src="assets/images/icons/{{boton.blanca}}" alt="">
                      <p>{{'FOCUS.REACTIVOS.STEPS.3.TEXTOS.'+idioma.clave+'.BOTONES.'+k | translate}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-template #sinReactivosMsg>
            <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
              <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                <h2>{{'FOCUS.REACTIVOS.SIN' | translate}}</h2>
                <mat-icon class="ml-20 s-40">error_outline</mat-icon>
              </div>
            </div>
          </ng-template>
        </ng-container>
          <ng-container *ngIf="idioma.tipoIdioma==0">
          <ng-container *ngIf="textosPreguntasFiltrados">
            <ng-container *ngFor="let idiomaPreg of textosPreguntasFiltrados; let j = index;" >
            <ng-container *ngIf="idiomaPreg.clave==idioma.clave">
            <ng-container *ngFor="let pregunta of idiomaPreg.preguntas; let o = index;" >

            <div fxLayout="column" fxLayoutAlign="start stretch" class="mat-elevation-z4 p-20 mb-20">
              <div fxLayout="row" fxLayoutAlign="start stretch">
                <h3><b>{{ (j+1) }}. {{ pregunta.traduccion }}</b></h3>
              </div>
              <div class="tac" fxLayout="row" fxLayoutAlign="space-around stretch">
                <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="45" *ngFor="let pespectiva of ['EMPRESA']">
                  <p>{{'FOCUS.REACTIVOS.STEPS.3.TEXTOS.'+idioma.clave+'.'+pespectiva | translate}}</p>
                  <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
                    <div class="botonReactivo" fxLayout="column" fxLayoutAlign="start center" fxFlex="16" *ngFor="let boton of botones; let k = index;">
                      <!-- <img *ngIf="guardados.caritas == 1" src="assets/images/icons/{{boton.amarilla}}" alt=""> -->
                      <img  src="assets/images/icons/{{boton.blanca}}" alt="">
                      <p>{{'FOCUS.REACTIVOS.STEPS.3.TEXTOS.'+idioma.clave+'.BOTONES.'+k | translate}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          </ng-container>
          </ng-container>
          </ng-container>

          <ng-template #sinReactivosMsg>
            <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
              <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
                <h2>{{'FOCUS.REACTIVOS.SIN' | translate}}</h2>
                <mat-icon class="ml-20 s-40">error_outline</mat-icon>
              </div>
            </div>
          </ng-template>
        </ng-container>

        </ng-template>

      </mat-step>

      <!-- Icon overrides. -->
      <ng-template matStepperIcon="idiomaIco">
          <mat-icon>language</mat-icon>
      </ng-template>
  </mat-horizontal-stepper>
</div>
